/*
 * @Author: mayanxia 
 * @Date: 2022-01-11 11:25:21 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:15:10
 */

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('规则名称')">
              <a-input :placeholder="$t('请输名称进行查询')" v-model="queryParam.warnName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('价格名称')">
              <a-select v-model="queryParam.priceId" :placeholder="$t('请选择用户价格名称')">
                <a-select-option v-for="data in priceList" :key="data.id" :value="data.id">
                  {{data.wtName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表口径')">
              <a-select v-model="queryParam.mtCaliber" :placeholder="$t('请选择表口径')">
                <a-select-option v-for="data in userCaliberList" :key="data.id" :value="data.mtCaliber">
                  DN{{data.mtCaliber}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!--
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
              -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="wtPriceSlot" slot-scope="text, record">
          <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
          <span v-else>--</span>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <meter-use-warn-config-modal ref="modalForm" @ok="modalFormOk"></meter-use-warn-config-modal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { listSize } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterUseWarnConfigModal from './modules/meterUseWarnConfigModal'
  import {isUndefined} from '@/utils/validate'
  import {messageTypeObj} from '@/utils/constants/commonConstant'
  import { getAction } from '@/api/manage'

  export default {
    name: 'MeterUseWarnConfigList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
        MeterUseWarnConfigModal
    },
    data () {
      return {
        description: this.$t('流量告警配置页面'),
        messageTypeObj,
        url: {
          list: "/jeecg-charge/meter/meterUseWarnConfig/list",
          delete: "/jeecg-charge/meter/meterUseWarnConfig/delete",
          deleteBatch: "/jeecg-charge/meter/meterUseWarnConfig/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUseWarnConfig/exportXls",
          importExcelUrl: "/jeecg-charge/meter/meterUseWarnConfig/importExcel",
          queryPrice: "/jeecg-charge/meter/meterPriceinfo/list",
          queryUserCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址,
          queryMeterUseWarnRecord:"/jeecg-charge/meter/meterUseWarnRecord/list"
        },
        dictOptions:{},
        priceList: [],
        userCaliberList: [],
      }
    },
    created() {
      this.queryPriceList()
      this.queryUserCaliberList()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('规则名称'),
            align:"center",
            dataIndex: 'warnName'
          },
          {
            title: this.$t('价格信息'),
            align:"center",
            dataIndex:'wtPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'wtPriceSlot' },
          },
          {
            title: this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              return 'DN'+text;
            }
          },
          {
            title: this.$t('是否启用'),
            align:"center",
            dataIndex: 'warnState',
            customRender: (t,r,index) => {
              let obj = {0: this.$t('未启用'),1: this.$t('启用')}
              if(!isUndefined(obj[t])) {
                return obj[t]
              }
              return this.$t('未知');
            }
          },
           {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      queryPriceList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.queryPrice, params).then((res) => {
          if(res.success){
            this.priceList = res.result.records;
          }
        }) 
      },
      queryUserCaliberList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.queryUserCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      handleEdit: function (record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterWarnConfigId = record.id
        getAction(this.url.queryMeterUseWarnRecord, params).then((res) => {
          if(res.success&&res.result.records.length>0){
            this.$refs.modalForm.isUsed = true;
          }else{
            this.$refs.modalForm.isUsed = false;
          }
          this.$refs.modalForm.disableSubmit = false;
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title = this.$t("编辑");
        })

        
      },
    }
  }
</script>
<style scoped>
</style>